import { ApiCallError } from 'app/http/ApiCallError';
import { getApiCallErrorMessage } from 'app/http/getApiCallErrorMessage';

const FALLBACK_MESSAGE = 'Failed to load jobs.';

export const getJobsListErrorMessage = (error: unknown) =>
  error instanceof ApiCallError ? getApiCallErrorMessage(error) : FALLBACK_MESSAGE;
